import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { api } from "../../environments/environment";
import { Message, RestService } from "@stdoutsrl/design-kit";
import { LoaderService } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-example-monouse-component",
  template: `<std-modal
    [show]="true"
    *transloco="let t"
    cardClass="!max-w-[90vw] min-w-[300px]"
    headerClass="bg-primary"
    [closeOnOutside]="false"
    (close)="autoDestory()"
  >
    <div header class="text-tertiary">{{ t("addOperator") }}</div>
    <div class="grid gap-4" content>
      <std-input
        customInputClass="custom-input"
        customLabel="label-input"
        labelPosition="top"
        type="file"
        [label]="t('image')"
        (change)="manageFile($event)"
      ></std-input>
      <std-input
        customInputClass="custom-input"
        customLabel="label-input"
        labelPosition="top"
        [label]="t('firstName')"
        [(ngModel)]="operator.firstName"
      ></std-input>
      <std-input
        customInputClass="custom-input"
        customLabel="label-input"
        labelPosition="top"
        [label]="t('lastName')"
        [(ngModel)]="operator.lastName"
      ></std-input>
      <std-select
        customLabel="label-input"
        [pipeTranslationLabelSelect]="t"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        customClassContaier="custom-select"
        customPillClass="!bg-primary"
        class="w-full"
        [label]="t('showInApp')"
        [placeholder]="t('needToComplete')"
        [currentValue]="{ value: 1, label: t('true') }"
        [closeOnSelection]="false"
        [currentValue]="{
          value: fatherElement?.showInApp,
          label: fatherElement?.showInApp == 0 ? t('false') : t('true')
        }"
        [data]="[
          { value: 0, label: t('false') },
          { value: 1, label: t('true') }
        ]"
        (onChangeValue)="changeInApp($event)"
      ></std-select>
      <std-select
        [currentValue]="fatherElement.items"
        customLabel="label-input"
        [pipeTranslationLabelSelect]="t"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
        customClassContaier="custom-select-multi"
        customPillClass="!bg-primary"
        class="w-full"
        bindLabel="name"
        [label]="t('services')"
        [closeOnSelection]="false"
        bindValue="id"
        [data]="listOfService"
        [multiple]="true"
        (onChangeValue)="changeSelectItems($event)"
      ></std-select>

      <div
        class="w-50% mt-4"
        [ngClass]="{
          'pointer-events-none opacity-50': false
        }"
      >
        <std-button
          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
          class="w-full"
          (click)="createOperator(t)"
          >{{ t("edit") }}</std-button
        >
      </div>
    </div>
  </std-modal>`,
  styles: [],
  standalone: false,
})
export class EditOperatorComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  listOfService: any = [];
  operator: any = {};
  formData = new FormData();
  listOfSelectedServices: any[] = [];
  api = api;

  constructor(
    private host: ElementRef<HTMLElement>,
    private rest: RestService,
    private loader: LoaderService,
    private message:Message
  ) {}

  ngOnInit(): void {
    this.getServices();
    this.operator = {
      firstName: this.fatherElement.firstName,
      lastName: this.fatherElement.lastName,
    };
  }

  changeInApp(event: any) {
    this.operator.showInApp = event.value;
  }

  manageFile(event: any) {
    this.formData = new FormData();
    this.formData.append("file", event.target.files[0]);
  }

  changeSelectItems(event: any) {
    this.listOfSelectedServices = event;
  }

  getServices() {
    this.listOfService = this.fatherContaierRef.tablesData.item;
    //
  }

  createOperator(t:any) {
    if(this.operator.firstName && this.operator.lastName){
    this.loader.on();
    this.formData.append("firstName", this.operator.firstName);
    this.formData.append("lastName", this.operator.lastName);
    this.formData.append("image", this.fatherElement.image);
    this.formData.append("showInApp", this.operator.showInApp);
    this.rest
      .put(
        `/company/${this.fatherContaierRef.myData.id}/operator/${this.fatherElement.id}`,
        this.formData
      )
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          let completedN = 0;
          this.listOfSelectedServices.forEach((element: any) => {
            this.loader.on();
            this.rest
              .post(`/operator/${value.id}/item/${element.id}`, {})
              .subscribe((res: any) => {
                completedN = completedN + 1;
                this.loader.off(true);
                if (completedN == this.listOfSelectedServices.length) {
                  this.fatherContaierRef.getSubTables();
                  this.autoDestory();
                }
              });
          });
          if (this.listOfSelectedServices.length == 0) {
            this.fatherContaierRef.getSubTables();
            this.autoDestory();
          }
        },
        error: (value) => {
          this.loader.off(true);
          this.fatherContaierRef.getSubTables();
          this.autoDestory();
        },
      });}else{
this.message.showMessage(t('completeAll'),'error')
      }
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
